import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';
import { fetchProjectUpdates } from '@/api/v4/project-updates.api';
import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useProjectUpdates = () => {
  const projectId = useAtomValue(projectIdState);

  return useQuery({
    queryKey: [QueryKey.ProjectUpdates, projectId],
    queryFn: () => (projectId ? fetchProjectUpdates(projectId) : undefined),
    enabled: !!projectId,
  });
};
